import React, { useState } from 'react';
import styled from 'styled-components';
import { sizes, media, colors } from 'styles/variables';
import { log } from 'utils/log';

export default props => {
	const lang = props.pageContext.lang || '';
	const [footer] = useState(require(`data/${lang}_footer`));

	const StyledWrapper = styled.div`
		padding: ${sizes[2]} ${sizes[1]};
		text-align: right;
		align-items: end;
		z-index: 9;
		${props.fixed === true &&
			`
			position:fixed;
			bottom:0;
			left:0;
			right:0;
		`};
		> * {
			padding: 0 ${sizes[1]};
			${media.small} {
				padding: ${sizes[1]};
			}
			a[href]:hover {
				text-decoration: underline;
			}
			font-size: 0.66rem;
			&.--prominent {
				text-transform: uppercase;
				font-weight: 600;
				font-size: 0.75rem;
				margin-bottom: -1px;
			}
		}
		${media.small} {
			white-space: nowrap;
			overflow: auto;
			background: rgba(0, 0, 0, 0.033);
			padding-left: ${sizes[1]} !important;
			${props.fixed === true &&
				`
				bottom:0;
				left:0;
				right:0;
				padding:0;
			`};
		}
	`;

	return (
		<StyledWrapper>
			{footer.map((item, index) => (
				<small
					key={index}
					onClick={() => {
						log(
							'Interaction',
							'Footer',
							`click--${item.title
								.split(' ')
								.join('_')
								.toLowerCase()}`,
						);
					}}
				>
					{item.link ? (
						<a href={item.link}>{item.title}</a>
					) : (
						<div>{item.title.replace('{year}', new Date().getFullYear())}</div>
					)}
				</small>
			))}
		</StyledWrapper>
	);
};
